import { render, staticRenderFns } from "./CallToButton.vue?vue&type=template&id=12939786&scoped=true&"
import script from "./CallToButton.vue?vue&type=script&lang=js&"
export * from "./CallToButton.vue?vue&type=script&lang=js&"
import style0 from "./CallToButton.vue?vue&type=style&index=0&id=12939786&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12939786",
  null
  
)

export default component.exports